module.exports = __webpack_public_path__ + "img/DE03483.6d250690.svg";